import { sheet } from 'emotion'

if document.querySelector('#app > #app-placeholder')? and WEBPACK_STATIC_BUILD is true
	console.log 'Speedy'
	sheet.speedy(false)
